function initHoverMenu() {
  const headerMenus = document.querySelectorAll("header-menu");
  
  if (headerMenus.length === 0) {
    setTimeout(initHoverMenu, 300);
    return;
  }

  headerMenus.forEach((headerMenu) => {
    const detailsElement = headerMenu.querySelector("details");
    if (!detailsElement) return;

    headerMenu.addEventListener("mouseenter", () => {
      headerMenus.forEach((other) => {
        if (other !== headerMenu) {
          const otherDetails = other.querySelector("details");
          if (otherDetails) {
            otherDetails.removeAttribute("open");
          }
        }
      });
      detailsElement.setAttribute("open", true);
    });

    headerMenu.addEventListener("mouseleave", () => {
      setTimeout(() => {
        if (!headerMenu.matches(":hover")) {
          detailsElement.removeAttribute("open");
        }
      }, 300);
    });
  });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initHoverMenu);
} else {
  initHoverMenu();
}
